(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (function () {
  /**
   * Card Variant Picker
   * Listens for radio changes inside .vpc-root forms, updates the
   * vpc-card--selected class, then dispatches a native "change" event
   * on the radio so Shopify's variant-picker web component (and any
   * other theme listeners) pick up the new selection and update price,
   * images, add-to-cart button, etc.
   */
  function initCardPicker(root) {
    var form = root.querySelector('.vpc-form');
    if (!form) return;

    form.addEventListener('change', function (e) {
      var radio = e.target;
      if (radio.type !== 'radio') return;

      // 1. Update selected-card styling within the same fieldset
      var fieldset = radio.closest('.vpc-fieldset');
      if (fieldset) {
        fieldset.querySelectorAll('.vpc-card').forEach(function (card) {
          card.classList.remove('vpc-card--selected');
        });
        radio.closest('.vpc-card').classList.add('vpc-card--selected');
      }

      // 2. Keep data-current-checked / data-previous-checked in sync
      //    (Shopify's variant-picker web component reads these)
      var name = radio.name;
      form.querySelectorAll('input[name="' + name + '"]').forEach(function (r) {
        r.setAttribute('data-previous-checked', r.getAttribute('data-current-checked'));
        r.setAttribute('data-current-checked', r.checked ? 'true' : 'false');
      });
    });
  }

  // Init all pickers already in the DOM
  document.querySelectorAll('variant-picker.vpc-root').forEach(initCardPicker);

  // Also handle any that are injected later (e.g. quick-view modals)
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('variant-picker.vpc-root')) {
            initCardPicker(node);
          }
          node.querySelectorAll && node.querySelectorAll('variant-picker.vpc-root').forEach(initCardPicker);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
